function normalizeAppUrl(value: string) {
  const url = new URL(value)
  url.hash = ''
  url.search = ''
  return url.toString().replace(/\/$/, '')
}

export function getPublicAppOrigin() {
  const configuredUrl = (import.meta.env.VITE_APP_URL as string | undefined)?.trim()

  if (configuredUrl) {
    try {
      return normalizeAppUrl(configuredUrl)
    } catch {
      // Fall back to the active origin when the override is invalid.
    }
  }

  if (typeof window !== 'undefined') return window.location.origin
  return ''
}

export function getSignupConfirmationRedirectUrl() {
  // Keep auth email callbacks on the configured public app URL when one is set.
  return `${getPublicAppOrigin()}/join/complete`
}

export function getPasswordResetRedirectUrl() {
  return `${getPublicAppOrigin()}/reset`
}
